<ul id="connect" class="profile-menu d-flex">
  <li *ngIf="authService.isLoggedIn$ | async" class="dropdown user">
    <button
      type="button"
      class="dropdown-toggle left-part hide-default-toggler-icon"
      data-bs-toggle="dropdown"
    >
      <span class="user-initials">
        <span>{{ (authService.currentUser$ | async)?.firstNameInitial }}</span>
        <span>{{ (authService.currentUser$ | async)?.lastNameInitial }}</span>
      </span>
      <span class="user-fullname">{{
        (authService.currentUser$ | async)?.fullName
      }}</span>
      <i class="fal fa-angle-down"></i>
    </button>
    <ul class="dropdown-menu dropdown-menu-end">
      <ng-container *ngIf="userIsSuperinspector">
        <li class="dropdown-item">
          <a target="_blank" class="dropdown-item-link" href="/inspector"
            ><i class="far fa-user-secret"></i>
            <ng-container i18n="@@inspector-link">Inspector</ng-container>
          </a>
        </li>
        <li class="divider"></li>
      </ng-container>
      <li class="dropdown-item">
        <a class="dropdown-item-link" routerLink="/"
          ><i class="far fa-user-vneck"></i>
          <ng-container i18n="@@part-a">Applicant</ng-container>
        </a>
      </li>
      <ng-container *ngIf="userIsSuperMario || userIsPartB">
        <ng-container *ngIf="!USE_NEW_PART_B_LINK">
          <li class="dropdown-item">
            <a
              target="_blank"
              class="dropdown-item-link"
              href="{{
                BASE_URL + eregistrationsTranslationService.language
              }}/part-b?attemptAutoLogin=1"
              ><i class="far fa-user-police-tie"></i>
              <ng-container i18n="@@part-b">Processor</ng-container>
              <ng-container *ngIf="userIsSuperinspector"> (old)</ng-container>
            </a>
          </li>
        </ng-container>
        <ng-container
          *ngIf="
            USE_NEW_PART_B_LINK ||
            (!USE_NEW_PART_B_LINK && userIsSuperinspector)
          "
        >
          <li class="dropdown-item">
            <a target="_blank" class="dropdown-item-link" href="/part-b"
              ><i class="far fa-user-police-tie"></i>
              <ng-container i18n="@@PartB">Part B</ng-container
              ><ng-container
                *ngIf="!USE_NEW_PART_B_LINK && userIsSuperinspector"
              >
                (new)</ng-container
              >
            </a>
          </li>
        </ng-container>
      </ng-container>
      <li class="divider"></li>
      <ng-container *ngIf="userIsSysadmin || userIsSuperMario">
        <li class="dropdown-item">
          <a class="dropdown-item-link" routerLink="/admin/users"
            ><i class="far fa-users-cog"></i>
            <ng-container i18n="@@user-management-link"
              >User Management</ng-container
            >
          </a>
        </li>
      </ng-container>
      <ng-container *ngIf="userIsSuperMario">
        <li class="dropdown-item">
          <a
            target="_blank"
            class="dropdown-item-link"
            href="{{ authAdminUrl }}"
            ><i class="far fa-shield-keyhole"></i>
            <ng-container i18n="@@Auth admin">Auth admin</ng-container>
          </a>
        </li>
        <li class="dropdown-item">
          <a target="_blank" class="dropdown-item-link" href="{{ bpaUrl }}"
            ><i class="far fa-sliders-simple"></i>
            <ng-container i18n="@@link-admin-bpa">BPA</ng-container>
          </a>
        </li>
        <li class="dropdown-item">
          <a target="_blank" class="dropdown-item-link" href="{{ statsUrl }}"
            ><i class="far fa-sliders-simple"></i>
            <ng-container i18n="@@link-admin-stats">Statistics</ng-container>
          </a>
        </li>
      </ng-container>
      <li class="divider"></li>

      <li class="dropdown-item" hidden>
        <a
          class="dropdown-item-link"
          (click)="
            globalStateProviderService.drawerOpen =
              !globalStateProviderService.drawerOpen
          "
          ><i class="far fa-paint-roller"></i>
          <ng-container i18n="@@UI configurator">UI configurator</ng-container>
        </a>
      </li>
      <ng-container *ngIf="keycloakActive">
        <li class="dropdown-item">
          <a class="dropdown-item-link" routerLink="/user/change-password"
            ><i class="far fa-key"></i>
            <ng-container i18n="@@change-password"
              >Change Password</ng-container
            >
          </a>
        </li>
      </ng-container>
      <ng-container *ngIf="authService.isLoggedIn$ | async">
        <li class="dropdown-item">
          <a class="dropdown-item-link" (click)="logout()">
            <i class="far fa-sign-out"></i>
            <ng-container i18n="@@logout">Logout</ng-container>
          </a>
        </li>
      </ng-container>
    </ul>
  </li>
  <app-login
    class="d-flex"
    *ngIf="(authService.isLoggedIn$ | async) === false"
  ></app-login>
</ul>
